import { lazy, Suspense } from 'preact/compat';

import { HabitatListItemTrailer } from '@/queries/habitats/types';

const ShareModal = lazy(() => import('@/components/ShareModal/Standalone'));

interface TrailerModalProps {
  trailer: HabitatListItemTrailer;
  onClose: () => void;
}

/**
 * The habitat trailer, played over the product card.
 *
 * `ShareModal` in its `mediaOnly` mode — the player and a close button, without the chat, tagging,
 * title editing and share rail it wears elsewhere. Same route `LiveChannelsBar/HabitatIcon` takes,
 * and lazy for the same reason: the player is a large chunk that most visitors never open.
 *
 * `skipDefaultCloseHandler` is load-bearing. Closing a share modal normally means leaving a piece of
 * media the URL was pointing at, so it runs `history.back()`; here there is a purchase flow behind
 * this modal that treats browser-back as "close", and the trailer would take it down on the way out.
 */
const TrailerModal = ({ trailer, onClose }: TrailerModalProps) => (
  <Suspense fallback={null}>
    <ShareModal
      open
      mediaOnly
      skipDefaultCloseHandler
      isDownloadAllowed={false}
      data={trailer}
      mediaId={trailer._id}
      onClose={onClose}
    />
  </Suspense>
);

export default TrailerModal;
